import { getImagePath, getSrcSetImagePath } from '../../utils/imagePath';
import {DPR_1, SLIDER_GRID_LRG, SLIDER_GRID_MED, SLIDER_GRID_SML, SLIDER_GRID_XSML} from '../../utils/constants';

const SMALL_WIDTH = 250,
    MEDIUM_WIDTH = 300,
    LARGE_WIDTH = 400,
    XLARGE_WIDTH = 580;

const LOGO_DESIGN = 'logodesign@2x.jpg',
    WORDPRESS = 'wordpress@2x.jpg',
    VOICE_OVER = 'voiceover@2x.jpg',
    WHITEBOARD = 'whiteboard@2x.jpg',
    SOCIAL = 'social@2x.jpg',
    SEO = 'seo@2x.jpg',
    ILLUSTRATION = 'illustration2x.jpg',
    TRANSLATION = 'translation2x.jpg',
    DATA_ENTRY = 'data-entry2x.jpg',
    BOOK_COVERS = 'books2x.jpg';

const componentDirectory = 'sub_category';

const getSmallSrcSetImagePath = (filename) => getSrcSetImagePath({width: SMALL_WIDTH, componentDirectory, img: filename});

const getSmallImagePath = (filename) => getImagePath({width: SMALL_WIDTH, dpr: DPR_1, componentDirectory, img: filename});

const getMediumSrcSetImagePath = (filename) => getSrcSetImagePath({width: MEDIUM_WIDTH, componentDirectory, img: filename});

const getLargeSrcSetImagePath = (filename) => getSrcSetImagePath({width: LARGE_WIDTH, componentDirectory, img: filename});

const getXlargeSrcSetImagePath = (filename) => getSrcSetImagePath({width: XLARGE_WIDTH, componentDirectory, img: filename});

const getPictureData = (filename) => [
    {
        srcSet: getSmallSrcSetImagePath(filename),
        media: SLIDER_GRID_LRG
    },
    {
        srcSet: getMediumSrcSetImagePath(filename),
        media: SLIDER_GRID_MED
    },
    {
        srcSet: getLargeSrcSetImagePath(filename),
        media: SLIDER_GRID_SML
    },
    {
        srcSet: getXlargeSrcSetImagePath(filename),
        media: SLIDER_GRID_XSML
    }
];

export const subCategories = [
    {
        name: 'creative_logo_design',
        subCategoryId: 49,
        categorySlug: 'graphics-design',
        subCategorySlug: 'creative-logo-design',
        image: {
            srcSet: getSmallSrcSetImagePath(LOGO_DESIGN),
            src: getSmallImagePath(LOGO_DESIGN)
        },
        picture: getPictureData(LOGO_DESIGN)
    },
    {
        name: 'wordpress_services',
        subCategoryId: 91,
        categorySlug: 'programming-tech',
        subCategorySlug: 'wordpress-services',
        image: {
            srcSet: getSmallSrcSetImagePath(WORDPRESS),
            src: getSmallImagePath(WORDPRESS)
        },
        picture: getPictureData(WORDPRESS)
    },
    {
        name: 'voice_overs',
        subCategoryId: 13,
        categorySlug: 'music-audio',
        subCategorySlug: 'voice-overs',
        image: {
            srcSet: getSmallSrcSetImagePath(VOICE_OVER),
            src: getSmallImagePath(VOICE_OVER)
        },
        picture: getPictureData(VOICE_OVER)
    },
    {
        name: 'whiteboard_explainer_videos',
        subCategoryId: 228,
        categorySlug: 'video-animation',
        subCategorySlug: 'whiteboard-explainer-videos',
        image: {
            srcSet: getSmallSrcSetImagePath(WHITEBOARD),
            src: getSmallImagePath(WHITEBOARD)
        },
        picture: getPictureData(WHITEBOARD)
    },
    {
        name: 'social_media',
        subCategoryId: 67,
        categorySlug: 'online-marketing',
        subCategorySlug: 'social-marketing',
        image: {
            srcSet: getSmallSrcSetImagePath(SOCIAL),
            src: getSmallImagePath(SOCIAL)
        },
        picture: getPictureData(SOCIAL)
    },
    {
        name: 'seo_services',
        subCategoryId: 65,
        categorySlug: 'online-marketing',
        subCategorySlug: 'seo-services',
        image: {
            srcSet: getSmallSrcSetImagePath(SEO),
            src: getSmallImagePath(SEO)
        },
        picture: getPictureData(SEO)
    },
    {
        name: 'illustration',
        subCategoryId: 50,
        categorySlug: 'graphics-design',
        subCategorySlug: 'digital-illustration',
        image: {
            srcSet: getSmallSrcSetImagePath(ILLUSTRATION),
            src: getSmallImagePath(ILLUSTRATION)
        },
        picture: getPictureData(ILLUSTRATION)
    },
    {
        name: 'translation',
        subCategoryId: 108,
        categorySlug: 'writing-translation',
        subCategorySlug: 'quality-translation-services',
        image: {
            srcSet: getSmallSrcSetImagePath(TRANSLATION),
            src: getSmallImagePath(TRANSLATION)
        },
        picture: getPictureData(TRANSLATION)
    },
    {
        name: 'data_entry',
        subCategoryId: 339,
        categorySlug: 'business',
        subCategorySlug: 'data-entry',
        image: {
            srcSet: getSmallSrcSetImagePath(DATA_ENTRY),
            src: getSmallImagePath(DATA_ENTRY)
        },
        picture: getPictureData(DATA_ENTRY)
    },
    {
        name: 'book_covers',
        subCategoryId: 51,
        categorySlug: 'graphics-design',
        subCategorySlug: 'cover-design',
        image: {
            srcSet: getSmallSrcSetImagePath(BOOK_COVERS),
            src: getSmallImagePath(BOOK_COVERS)
        },
        picture: getPictureData(BOOK_COVERS)
    }
];
